function nameWords(name: string): string[] {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .split(/[^a-z]+/)
    .filter((word) => word.length > 2);
}

/**
 * Vrai si les deux noms ont au moins un mot en commun, sans tenir compte de la casse, des accents
 * ni des tirets (« Jean-Claude BENNERY » ≈ « BENNERY Jean Claude »). Les mots de deux lettres ou
 * moins (« de », « la ») sont ignorés : ils rapprocheraient des personnes différentes.
 */
export default function namesShareAWord(a: string, b: string): boolean {
  const wordsOfB = nameWords(b);
  return nameWords(a).some((word) => wordsOfB.includes(word));
}
